'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQSection = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'What areas do you deliver to?',
      answer:
        'We currently deliver to Culinary City and surrounding areas within a 10-mile radius. Enter your address during checkout to confirm delivery availability.',
    },
    {
      question: 'What payment methods do you accept?',
      answer:
        'We accept cash on delivery, credit/debit cards, and online payments through our secure payment gateway. All major cards are supported.',
    },
    {
      question: 'How long does delivery typically take?',
      answer:
        'Standard delivery takes 30-45 minutes depending on your location and order complexity. You can track your order in real-time through our app.',
    },
    {
      question: 'Do you offer catering services?',
      answer:
        'Yes! We provide catering services for events, parties, and corporate gatherings. Please contact us at least 48 hours in advance with your requirements.',
    },
    {
      question: 'Can I modify or cancel my order?',
      answer:
        'Orders can be modified or cancelled within 5 minutes of placement. After that, please contact our support team immediately for assistance.',
    },
    {
      question: 'Do you accommodate dietary restrictions?',
      answer:
        'Absolutely! We offer vegetarian, vegan, gluten-free, and other dietary options. Use our menu filters or add special instructions during checkout.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="mt-12">
      <div className="mb-8 text-center">
        <h2 className="font-heading text-h2 mb-3 text-foreground">Frequently Asked Questions</h2>
        <p className="text-muted-foreground">
          Find quick answers to common questions about our services
        </p>
      </div>

      <div className="mx-auto max-w-3xl space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg border border-border bg-card shadow-sm transition-smooth"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="flex w-full items-center justify-between px-6 py-4 text-left transition-smooth hover:bg-muted/50 focus-ring"
              aria-expanded={expandedIndex === index}
            >
              <span className="pr-4 font-semibold text-foreground">{faq.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={20}
                className={`flex-shrink-0 text-primary transition-transform ${
                  expandedIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>

            {expandedIndex === index && (
              <div className="border-t border-border bg-muted/30 px-6 py-4">
                <p className="text-sm leading-relaxed text-muted-foreground">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Still Have Questions */}
      <div className="mt-8 text-center">
        <p className="text-sm text-muted-foreground">
          Still have questions?{' '}
          <a href="#contact-form" className="font-medium text-primary hover:underline focus-ring">
            Send us a message
          </a>{' '}
          and we'll get back to you shortly.
        </p>
      </div>
    </div>
  );
};

export default FAQSection;
